<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix">
      <div class="pull-left">
        <h3 class="m-v-0">{{collection.name}}</h3>
      </div>
    </div>
    <hr>
    <el-form :model="collection" :rules="rules" label-width="6em" label-position="left" class="m-v-5" ref="form">
      <el-form-item label="所属部门">
        {{department_map[collection.department_uid]}}
      </el-form-item>
      <el-form-item label="发布日期">
        {{collection.time_create | sub(0, -3)}}
      </el-form-item>
      <el-form-item label="具体要求">
        <span class="text-pre-wrap l-h-n m-t-8">{{collection.desc}}</span>
      </el-form-item>
      <el-form-item label="附件" v-if="collection.file">
        <a :href="collection.file.url" :download="collection.file.name" target="_blank" class="link-success">
          <icon :name="collection.file.name | fileicon"></icon>
          {{collection.file.name}}
        </a>
      </el-form-item>
      <hr>
      <el-form-item label="提交文件" prop="teacher_file">
        <select-file @change="selectFile" class="m-r-20">
          <el-button type="success" size="small">
            {{collection.teacher_file ? '重新选择' : '选择文件'}}
          </el-button>
        </select-file>
        <template v-if="collection.teacher_file">
          <icon :name="collection.teacher_file.name | fileicon"></icon>
          {{collection.teacher_file.name}}
        </template>
      </el-form-item>
      <div class="text-center m-v-10">
        <el-button type="success" size="cons" @click="submit()" :loading="submit_loading>0">提交</el-button>
        <el-button type="default" size="cons" @click="$router.back()">返回</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import keyBy from 'lodash/keyBy'
import mapValues from 'lodash/mapValues'
import pick from 'lodash/pick'

import * as Collection from 'api/collection'
import * as Department from 'api/department'

export default {
  data () {
    return {
      collection: null,
      search: '',
      department_map: null,
      submit_loading: 0,
      rules: {
        teacher_file: [this.$rules.required({message: '请选择文件上传', type: 'object'})],
      },
      ready: false,
    }
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [collection, departments] = await Promise.all([
          Collection.teacher_get({uid: this.$query.collection_uid}),
          Department.list(),
        ])
        this.department_map = mapValues(keyBy(departments, 'uid'), 'name')
        this.collection = collection
        this.ready = true
      })
    },
    selectFile (files) {
      this.collection.teacher_file = files[0]
    },
    async submit () {
      let message = await this.$validate(this.$refs.form, 'teacher_file')
      if (message) return this.$message(message)
      this.$guard(this, 'submit_loading')(async () => {
        await Collection.teacher_edit(pick(this.collection, 'uid', 'teacher_desc', 'teacher_file'))
        this.$message.success('提交成功')
        this.$router.back()
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/collection/CollectionEdit.vue